module.exports = __webpack_public_path__ + "img/onboarding_paso1.6ad0e1ed.svg";